import React, { useEffect, useState } from 'react';
import firebase from '../Services/firebase';
import { Button, makeStyles } from '@material-ui/core';
import colors from '../Styles/Colors'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'inline-block',
    },
    aroundImage: {
        width: '100px',
        borderRadius: '100px',
        padding: '2px',
        border: 'solid #f57542 5px',
        margin: '5px 0',
        display: 'flex',
        cursor: 'pointer',

        '&:hover': {
            borderColor: colors.dark_orange,
        },

        '&:focus': {
            borderColor: colors.dark_red,
        }
    },
    roundImg: {

        width: '100%',
        borderRadius: '100px',

    },
    text: {
        fontSize: '20px',
    }
}))
function TypeButton(props) {

    const styles = useStyles();


    return (
        <div className={styles.root}>
            <Button onClick={props.onClick} style={{ borderRadius: '100px', margin: '0' }}>
                <div className={styles.aroundImage}>
                    <img className={styles.roundImg} onLoad={props.ImageLoad} src={`/categorias/${props.nome}.jpg`} />
                </div>
            </Button>
            <div className={styles.text}>
                {props.nome}
            </div>
        </div>
    );
}

export default TypeButton;